<template>
    <div>
        <h5 class="mt-1 mb-4">{{ $t('adjunct_information').toUpper() }}</h5>
        <datatable
            :isLoading.sync="datatable.isLoading"
            :columns="datatable.columns"
            :rows="datatable.rows"
            :total="datatable.total"
            :queryParams="datatable.queryParams"
            @on-page-change="onPageChange"
            @on-sort-change="onSortChange"
            @on-per-page-change="onPerPageChange"
            v-show="datatable.showTable"
        >
        </datatable>

        <CommonModal
            ref="updateFormModal"
            size="xl"
            :onHideOnlyX="true"
            @bHideModalHeaderClose="formClear"
            v-if="checkPermission('adjunctpayment_update')"
        >
            <template v-slot:CommonModalTitle>
                {{ $t("edit").toUpper() }}
            </template>
            <template v-slot:CommonModalContent>
                <update-form
                    :formId="formId"
                    @updateFormSuccess="updateFormSuccess"
                    v-if="formProcess == 'update'"
                />
            </template>
        </CommonModal>
    </div>
</template>
<script>
// Component
import CommonModal from "@/components/elements/CommonModal.vue";
// Service
import UpdateForm from "@/modules/adjunctPayment/pages/UpdateForm.vue";
import Datatable from "@/components/datatable/Datatable.vue";
import qs from "qs";
import AdjunctPaymentService from "@/services/AdjunctPaymentService";
import moment from "moment/moment";
export default {
    components: {
        Datatable,
        UpdateForm,
        CommonModal,
    },
    props:{
      userId:{
          type:Number
      }
    },
    metaInfo() {
        return {
            title: this.$t("adjunct_payments"),
        };
    },
    data() {
        return {
            statusData: [
                { value: null, text: "" },
                { value: "a", text: this.$t("active") },
                { value: "p", text: this.$t("passive") },
            ],
            datatable: {
                isLoading: false,
                columns: [
                    {
                        label: "",
                        field: "buttons",
                        html: true,
                        sortable: false,
                        tdClass: "p-0 text-center w-40 align-middle",
                        buttons: [
                            {
                                text: this.$t("edit"),
                                class: "ri-edit-box-line",
                                permission: "adjunctpayment_update",
                                callback: (row) => {
                                    this.updateFormShow(row.id);
                                },
                            },
                        ],
                    },
                    {
                        label: this.toUpperCase("id"),
                        field: "id",
                        hidden: true,
                    },

                    {
                        label: this.toUpperCase("teaching_staff"),
                        field: "instructor_name",
                        hidden: false,
                        formatFn: (value, row) => {
                            return row.instructor_name + " " + row.instructor_surname;
                        },
                    },
                    {
                        label: this.toUpperCase("semester"),
                        field: "semester",
                        formatFn: (row, value) => {
                            return value.academic_year + ' / ' + value.semester;
                        },
                        hidden: false
                    },
                    {
                        label: this.toUpperCase("amount"),
                        field: "amount",
                        hidden: false,
                        formatFn: (value, row) => {
                            return parseFloat(row.amount).toFixed(2) + ' ' + row.currency;
                        },
                    },
                    {
                        label: this.toUpperCase("comments"),
                        field: "explanation",
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase("expertise_type"),
                        field: "expertise_type_name",
                        hidden: false,
                    },

                ],
                rows: [],
                total: 0,
                filterStatus: true,
                showTable: false,
                queryParams: {
                    filter: {
                        instructor_id: this.userId,
                    },
                    sort: "id",
                    page: 1,
                    limit: 20,
                },
            },
            formProcess: null,
            formId: null,
            form: {},
        };
    },
    created() {
        this.getRows()
        this.formClear();
    },
    methods: {
        filterSet() {
            this.datatable.queryParams.filter = {};
        },
        filterClear() {
            this.filterSet();
            this.getRows();
        },
        filter() {
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        onPageChange(params) {
            this.datatable.queryParams.page = params.currentPage;
            this.getRows();
        },
        onPerPageChange(params) {
            this.datatable.queryParams.limit = params.currentPerPage;
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        onSortChange(params) {
            const sortType = params[0].type == "desc" ? "-" : "";
            this.datatable.queryParams.sort = sortType + params[0].field;
            this.getRows();
        },
        getRows() {
            this.datatable.showTable = true;
            this.datatable.isLoading = true;

            const config = {
                params: {
                    ...this.datatable.queryParams,
                },
                paramsSerializer: (params) =>
                    qs.stringify(params, { encode: false }),
            };

            return AdjunctPaymentService.getAll(config)
                .then((response) => {
                    this.datatable.rows = response.data.data;
                    this.datatable.total = response.data.pagination.total;

                    this.datatable.rows.forEach(
                        (c) =>
                            (c.status =
                                c.status == "a"
                                    ? this.$t("active")
                                    : this.$t("passive"))
                    );
                    this.datatable.rows.forEach(
                        (c) =>
                            (c.updated_at = moment(c.updated_at).format(
                                "DD.MM.YYYY"
                            ))
                    );
                })
                .finally(() => {
                    this.datatable.isLoading = false;
                });
        },

        // Clear
        formClear() {
            this.formId = null;
            this.formProcess = null;
        },

        // Update
        updateFormShow(id) {
            this.formId = id;
            this.formProcess = "update";
            this.$refs.updateFormModal.$refs.commonModal.show();
        },
        updateFormSuccess() {
            this.$refs.updateFormModal.$refs.commonModal.hide();
            this.getRows();
            this.formClear();
        },
    },
}
</script>
